import { useEffect, useState } from 'react'

/// HH:MM:SS countdown that ticks once per second. Isolates the
/// re-render to this component so the surrounding page doesn't
/// thrash every second just to move digits.
///
///   <LiveCountdown endSec={launchSec + SEC_PER_DAY} style={...} />
///
/// `endSec` is a unix timestamp (seconds). Re-derives on each tick.
/// Rendering stops at 00:00:00; does not go negative.
///
/// `nowSec` (optional) anchors the countdown to CHAIN time instead of the browser wall clock. An
/// on-chain deadline (`endSec`) is measured against `block.timestamp`, and the two clocks diverge on a
/// dev fork whose block time has been advanced - there the browser clock reads the deadline as days
/// out. Pass the chain's current timestamp and the countdown ticks relative to it (anchored at mount,
/// advanced by real elapsed seconds). Omit it on mainnet, where chain time tracks wall-clock closely.
export function LiveCountdown({ endSec, nowSec, style = {}, prefix = '' }) {
  const [, tick] = useState(0)
  const [mountWall] = useState(() => Math.floor(Date.now() / 1000))
  useEffect(() => {
    const id = setInterval(() => tick((x) => x + 1), 1000)
    return () => clearInterval(id)
  }, [])
  const now = nowSec != null
    ? nowSec + (Math.floor(Date.now() / 1000) - mountWall)
    : Math.floor(Date.now() / 1000)
  const remaining = Math.max(0, (endSec ?? 0) - now)
  return <span style={style}>{prefix}{fmtHMS(remaining)}</span>
}

function fmtHMS(sec) {
  const s = Math.max(0, Math.floor(sec))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const ss = s % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}`
}
